import { memo } from 'react';
import PropTypes from 'prop-types';

/**
 * The category labels under a plot, spread edge to edge.
 *
 * `justify-between` rather than an even grid: the first and last labels have to
 * sit under the first and last marks, and a grid centres them one half-column
 * inwards.
 *
 * @param {object} props
 * @param {string[]} props.labels
 */
function ChartAxisLabels({ labels }) {
  if (!labels.length) return null;

  return (
    <div className="mt-1.5 flex justify-between">
      {labels.map((label) => (
        <span key={label} className="text-[10px] text-content-muted">
          {label}
        </span>
      ))}
    </div>
  );
}

ChartAxisLabels.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default memo(ChartAxisLabels);
